import { Injectable } from '@angular/core';
import { Api } from '../services/api';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(public api: Api) {
  }


  getActiveStores() {
    let seq = this.api.get('master/v1/getActiveStores');
    return seq;
  }
  
  getMappedStores(maSourceId) {
    let seq = this.api.get('master/v1/getMappedStores/'+maSourceId);
    return seq;
  }
}
